import { z } from 'zod';
import { FREQUENCIES, WEEKDAYS } from '../recurrence.js';
import { idSchema } from './common.js';
/**
 * Wiederholungsregel setzen (SPEC 9.4).
 *
 * Die Bestandteile werden einzeln validiert statt als roher RRULE-String:
 * so kann die API keine Regel speichern, die `parseRrule` spaeter nicht mehr
 * liest — und der Scheduler stuende vor einer Karte, die sich nie wieder
 * meldet.
 */
export const recurrenceSchema = z.object({
    freq: z.enum(FREQUENCIES),
    interval: z.number().int().min(1).max(366).default(1),
    byDay: z.array(z.enum(WEEKDAYS)).min(1).max(7).optional(),
    /** 1–31 oder -1 fuer den letzten Tag des Monats. */
    byMonthDay: z.number().int().min(-1).max(31).refine((day) => day !== 0).optional(),
    /**
     * Nutzer-IDs in Rotationsreihenfolge. Leer oder weggelassen: die
     * Verantwortlichen der Vorlage bleiben.
     */
    rotation: z.array(idSchema).max(20).optional(),
});
//# sourceMappingURL=recurrence.js.map